export const INPUT_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'password', label: 'Password' },
  { value: 'email', label: 'Email' },
  { value: 'tel', label: 'Tel' },
  { value: 'url', label: 'URL' },
  { value: 'search', label: 'Search' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'time', label: 'Time' },
  { value: 'datetime-local', label: 'DateTime Local' },
  { value: 'month', label: 'Month' },
  { value: 'week', label: 'Week' },
  { value: 'color', label: 'Color' },
  { value: 'file', label: 'File' },
  { value: 'range', label: 'Range' }
];

export const BULMA_COLORS = [
  { value: '', label: 'Default' },
  { value: 'is-primary', label: 'Primary' },
  { value: 'is-link', label: 'Link' },
  { value: 'is-info', label: 'Info' },
  { value: 'is-success', label: 'Success' },
  { value: 'is-warning', label: 'Warning' },
  { value: 'is-danger', label: 'Danger' },
  { value: 'is-white', label: 'White' },
  { value: 'is-light', label: 'Light' },
  { value: 'is-dark', label: 'Dark' },
  { value: 'is-black', label: 'Black' }
];

export const BULMA_SIZES = [
  { value: '', label: 'Normal' },
  { value: 'is-small', label: 'Small' },
  { value: 'is-medium', label: 'Medium' },
  { value: 'is-large', label: 'Large' }
];

export const BULMA_STYLES = [
  { value: '', label: 'Default' },
  { value: 'is-rounded', label: 'Rounded' }
];

export const BULMA_STATES = [
  { value: '', label: 'Normal' },
  { value: 'is-hovered', label: 'Hovered' },
  { value: 'is-focused', label: 'Focused' },
  { value: 'is-active', label: 'Active' },
  { value: 'is-loading', label: 'Loading' }
];

export const FONT_FAMILIES = [
  { value: 'inherit', label: 'Inherit' },
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Helvetica, sans-serif', label: 'Helvetica' },
  { value: "'Times New Roman', serif", label: 'Times New Roman' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: "'Courier New', monospace", label: 'Courier New' },
  { value: 'Verdana, sans-serif', label: 'Verdana' }
];

export const DEFAULT_PROPS = {
  name: "",
  qwantumId: "",
  value: "",
  inputName: "",
  placeholder: "Enter text",
  type: "text",
  readonly: false,
  disabled: false,
  allowEditing: true,
  bulmaSize: "",
  bulmaColor: "",
  bulmaStyle: "",
  bulmaState: "",
  hasLeftIcon: false,
  hasRightIcon: false,
  leftIconClass: "fas fa-user",
  rightIconClass: "fas fa-check",
  labelText: "",
  labelFontSize: 14,
  showSemicolon: true,
  labelBold: true,
  labelItalic: false,
  fontFamily: "inherit",
  width: "100%",
  maxWidth: null,
  minWidth: null,
  flex: null,
  flexGrow: null,
  flexShrink: null,
  flexBasis: null,
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  unit: 'px',
  lockedEdges: { top: false, left: false, right: false, bottom: false },
  backgroundColor: '',
  borderRadius: 0,
  padding: 0,
  cssClass: '',
  inputClass: ''
};